import * as React from 'react';
import {GalleryGridItemType} from '../../../constants';
import type {GalleryGridItem, IPromotion} from '../../../types/galleryTypes';
import {PromotionItem} from './PromotionItem/PromotionItem';

interface GridItemProps {
  gridItem: GalleryGridItem;
  index: number;
  ProductItem: Function;
  onAnnounce: (content: string) => void;
  setItemRef: (index: number, ref: any) => void;
  onPromotionItemClick?: (params: {promotion: IPromotion; event: React.MouseEvent<HTMLAnchorElement>}) => void;
}

export const GridItem = ({
  gridItem,
  index,
  ProductItem,
  onAnnounce,
  setItemRef,
  onPromotionItemClick,
}: GridItemProps) => {
  const isProduct = gridItem?.type === GalleryGridItemType.Product;

  return isProduct ? (
    <ProductItem
      index={index}
      product={gridItem.data}
      innerRef={(ref) => setItemRef(index, ref)}
      announce={onAnnounce}
    />
  ) : (
    <PromotionItem
      promotion={gridItem.data}
      onClick={(event) =>
        onPromotionItemClick?.({
          promotion: gridItem.data,
          event,
        })
      }
    />
  );
};
